import getCalculatedValues from '../../../lib/guidebook/get-calculated-values';

const sectionLocked = (state, config, id) => {
  const { lockedSections } = getCalculatedValues(state, config);
  return lockedSections.has(id);
};

export default sectionLocked;
